import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import {
  getMarketReportSignedUrl,
  putMarketReportPdf,
} from "../../lib/marketReportRequests";
import useStyles from "../util/styles";

export type UploadedPdf = {
  fileUrl: string;
  fileKey: string;
  fileName: string;
};

export default function PdfUpload({
  onUploaded,
  onError,
}: {
  onUploaded: (pdf: UploadedPdf) => void;
  onError: (message: string) => void;
}) {
  const classes = useStyles();
  const [upload, setUpload] = React.useState<{
    isUploading: boolean;
    hover: boolean;
  }>({
    isUploading: false,
    hover: false,
  });

  const onDrop = useCallback(
    async (files: any) => {
      if (files.length === 0) return;
      setUpload({ isUploading: true, hover: false });

      const file = files[0];
      try {
        const response = await getMarketReportSignedUrl(file.name, file.type);
        const { signedUrl, fileUrl, fileKey } = response.data;

        await putMarketReportPdf(signedUrl, file);
        onUploaded({ fileUrl, fileKey, fileName: file.name });
      } catch (err: any) {
        // post() rejects with the API's `err` string, not an Error
        const message =
          typeof err === "string"
            ? err
            : err?.message || "The PDF could not be uploaded.";
        onError(message);
      } finally {
        setUpload({ isUploading: false, hover: false });
      }
    },
    [onUploaded, onError]
  );

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: ".pdf,application/pdf",
    multiple: false,
  });

  return (
    <div style={{ margin: 16 }}>
      <div
        {...getRootProps()}
        onMouseEnter={() => setUpload({ ...upload, hover: true })}
        onMouseLeave={() => setUpload({ ...upload, hover: false })}
        className={
          upload.hover ? classes.imageUploadHover : classes.imageUpload
        }
      >
        <input {...getInputProps()} />
        {upload.isUploading ? (
          <p>Uploading ...</p>
        ) : isDragReject ? (
          <p>Wrong file type. .pdf required</p>
        ) : isDragActive ? (
          <p>Drop .pdf here</p>
        ) : (
          <p>Drop .pdf here</p>
        )}
      </div>
    </div>
  );
}
